module.exports = __webpack_public_path__ + "img/lab3.23d001db.png";